import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Get Entity Type Status',
  make: (entityTypeId: string) => ({
    request: () => ({ http }: any) =>
      http({
        method: 'GET',
        route: `/entity-types/${entityTypeId}/status`,
      }),
  }),
});
